import type { MatchReplaceRule } from '../store/proxy-store';

export function mergeMatchReplaceRulesFromServer({
  localRules,
  serverRules,
  dirtyRuleIds,
}: {
  localRules: MatchReplaceRule[];
  serverRules: MatchReplaceRule[];
  dirtyRuleIds: ReadonlySet<string>;
}): MatchReplaceRule[] {
  const serverById = new Map(serverRules.map((rule) => [rule.id, rule]));
  const merged: MatchReplaceRule[] = [];
  const seen = new Set<string>();

  for (const localRule of localRules) {
    if (dirtyRuleIds.has(localRule.id)) {
      merged.push(localRule);
      seen.add(localRule.id);
      continue;
    }

    const serverRule = serverById.get(localRule.id);
    if (serverRule) {
      merged.push(serverRule);
      seen.add(localRule.id);
    }
  }

  for (const serverRule of serverRules) {
    if (seen.has(serverRule.id)) {
      continue;
    }

    if (dirtyRuleIds.has(serverRule.id)) {
      continue;
    }

    merged.push(serverRule);
  }

  return merged;
}

export function deriveMatchReplaceEnabledFromRules(
  rules: MatchReplaceRule[],
): boolean {
  return rules.some((rule) => rule.enabled);
}
